import React, { Fragment } from "react";
import Element from "./Element";

type Props = {
	traversal: string[];
	fid: string;
};

function RenderElements({ traversal = [], fid }: Props) {
	return (
		<Fragment>
			{traversal.map(uuid => (
				<Element key={uuid} uuid={uuid} fid={fid} rowIndex={0} />
			))}
		</Fragment>
	);
}

export default RenderElements;
